import type React from "react";
import { ReactComponent as Svg } from "./assets/cross-icon.svg";
import * as styles from "./Icon.module.scss";

type LegLoseProps = React.SVGProps<SVGSVGElement>;

export const LegLose = ({ className, ...props }: LegLoseProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
